<script setup lang="ts">
  interface Props {
    scrollableElement?: HTMLElement | SVGElement | Window | Document | null
    canLoad?: boolean
  }

  interface Emits {
    (e: 'load'): void
  }

  const props = defineProps<Props>()

  const emit = defineEmits<Emits>()

  const { isLoading, reset } = useInfiniteScroll(props.scrollableElement ?? window, () => emit('load'), {
    distance: 10,
    canLoadMore: (el) => {
      if (!props.canLoad) {
        return false
      }

      if (!(el instanceof HTMLElement)) {
        return false
      }

      // Не подгружаем, пока контент не переполняет контейнер
      return el.scrollHeight > el.clientHeight
    },
  })
</script>

<template>
  <div>
    <slot :reset="reset" />
    <slot
      name="loader"
      :is-loading="isLoading"
    />
  </div>
</template>
